import React from 'react';
import { usePublicList } from '../hooks/usePublicList';

function TimelineContent({ title, bullets }) {
  return (
    <div className="timeline-content">
      <h4>{title}</h4>
      {bullets && bullets.length > 0 && (
        <ul className="bullets">
          {bullets.map((b) => <li key={b}>{b}</li>)}
        </ul>
      )}
    </div>
  );
}

function TimelineRow({ item, isLeft }) {
  return (
    <div className={'timeline-row ' + (isLeft ? 'left' : 'right')}>
      <div className="col-left">
        {isLeft && <span className="timeline-period">{item.period}</span>}
        {!isLeft && <TimelineContent title={item.title} bullets={item.bullets} />}
      </div>
      <div className="timeline-dot" />
      <div className="col-right">
        {!isLeft && <span className="timeline-period">{item.period}</span>}
        {isLeft && <TimelineContent title={item.title} bullets={item.bullets} />}
      </div>
    </div>
  );
}

export default function About() {
  const { data: timeline, loading } = usePublicList('timeline');
  const sorted = [...timeline].sort((a, b) => a.order - b.order);
  return (
    <section className="section">
      <div className="container">
        <h2 className="section-title">Haqqımda</h2>
        <p className="section-subtitle">Təcrmübəm və karyera yolum</p>
        {loading ? <p style={{ textAlign: 'center', color: '#6b7280' }}>Yüklənir...</p> : (
          <div className="timeline">
            {sorted.map((t, idx) => (
              <TimelineRow key={t.id} item={t} isLeft={idx % 2 === 0} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
